import { CloseIcon } from 'modules/icons';

interface INotificationCloseProps {
  onClick?: () => void;
}

export function NotificationClose({
  onClick,
}: INotificationCloseProps): JSX.Element {
  return (
    <div onClick={onClick}>
      <CloseIcon />
    </div>
  );
}
